<template>
  <div :class="['footer-container', { collapsed: collapsed} ]">
    <div class="input-container">
      <div class="input-content">
        <!-- Icons (currently hidden, future features) -->
        <div v-show="false" class="icon-container">
          <div class="icon">
            <img
              :src="require('@/assets/icons/microphone-icon.svg')"
              alt="Microphone Icon" />
          </div>
          <div class="icon">
            <img
              :src="require('@/assets/icons/image-icon.svg')"
              alt="Image Icon" />
          </div>
        </div>

        <!-- Thinking dots while waiting for API -->
        <div v-if="isThinking" class="thinking-indicator">
          <span class="dot"></span><span class="dot"></span><span class="dot"></span>
        </div>

        <!-- Multiline textbox -->
        <!-- <textarea v-else class="input-text" v-model="message" placeholder="Type a message" :disabled="isDisabled"
          @input="resizeInput"
          @keydown.enter.exact.prevent="sendMessage"></textarea> -->


        <div
          ref="editor"
          :contenteditable="!isDisabled"
          class="input-text"
          @input="onInput"
          @keydown.enter.exact.prevent="sendMessage"
          :data-placeholder="isDisabled ? '' : 'Ask CamGPT'"
        ></div>

        <!-- Send icon -->
        <div class="send-icon"
          :class="{ 'send-icon-enabled': message.trim() !== '' }"
          @click="sendMessage">
          <img
            :src="require('@/assets/icons/send-icon.svg')"
            alt="Send Icon" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatFooter',
  props: {
    isThinking: Boolean,
    collapsed: Boolean
  },
  data() {
    return {
      message: '',
      isDisabled: false
    };
  },
  methods: {
    onInput() {
      this.message = this.$refs.editor.innerText;

      if (this.message.trim() === '') {
        this.$refs.editor.innerHTML = '';
      }
      this.resizeInput();
    },
    sendMessage() {
      // Only send on non‑empty message and when not disabled
      if (this.message.trim() && !this.isDisabled) {
        this.isDisabled = true;
        this.$emit('send-message', this.message.trim());
        this.message = '';
        this.$nextTick(() => {
          this.$refs.editor.innerHTML = '';
          this.resizeInput();
        }); 
      }
    },
    enableInput() {
      this.isDisabled = false;
    },
    resizeInput() {
      const editor = this.$refs.editor;
      if (!editor) return;
      editor.style.height = 'auto';

      // If message is empty, keep a minimum height
      if (!this.message.trim()) {
        editor.style.height = '3.1rem'; // matches .input-text min-height
      } else {
        editor.style.height = editor.scrollHeight + 'px';
      }

    },
    loadConversation(conversation) {
      this.$emit('load-conversation', conversation);
    }
  }
};
</script>

<style scoped>
.footer-container {
  z-index: 2;
  width: calc(100% - 20.00rem);
  /* subtract sidebar */
  display: flex;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  position: fixed;
  bottom: 0;
  padding: 1rem;
  padding-top: .95rem;
  box-sizing: border-box;
}

.footer-container.collapsed {

  width: calc(100% - 5.80rem);
  box-sizing: content-box;
}

.input-container {
  width: 100%;
  max-width: 800px;
  background: #F7F9FB;
  border-radius: 1rem;
  padding: 0.25rem;
  box-sizing: border-box;
  border: 1px solid #ccc;
}

.input-content {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  width: 100%;
}

.icon-container {
  display: flex;
  gap: 1rem;
}

.icon {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.input-text {
  flex: 1;
  min-height: 2.5rem;
  max-height: 450px;
  font-size: 1rem;
  font-family: Inter, sans-serif;
  line-height: 1.5rem;
  padding: 0.8rem 0.8rem;
  resize: none;
  border: none;
  outline: none;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-word;
  box-sizing: border-box;
}

.input-text[contenteditable="false"] {
  cursor: pointer !important;
  caret-color: transparent !important;
  user-select: none;
}

[contenteditable]:empty::before {
  content: attr(data-placeholder);
  color: #aaa;
  pointer-events: none;
}

.input-text::-webkit-scrollbar {
  width: 8px;
}

.input-text::-webkit-scrollbar-track {
  background: transparent;
}

.input-text::-webkit-scrollbar-thumb {
  background-color: #555;
  border-radius: 10px;
}

.input-text::-webkit-scrollbar-thumb:hover {
  background-color: #888;
}

.send-icon {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 5px;
  align-self: flex-end;
  margin-bottom: 7px;
}

.send-icon-enabled {
  background: #d6d9db;
  border-radius: 50%;
}

.thinking-indicator {
  display: flex;
  gap: 5px;
  margin: 10px 0;
  padding: 10px 0;
  margin-left: 15px;
}

.dot {
  width: 8px;
  height: 8px;
  background: gray;
  border-radius: 50%;
  animation: blink 1.4s infinite both;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes blink {

  0%,
  80%,
  100% {
    opacity: 0;
  }

  40% {
    opacity: 1;
  }
}
</style>